/**
 * Phone: the Explorer tree as its own page, "Projects and lanes" (`/tree`, concept `ide-tree`),
 * reached from the top bar's place switcher. The same rows, keys and counts as the desktop sidebar,
 * full width with 44 px rows.
 */
import { useNavigate } from '@tanstack/react-router'
import { useMemo, useState } from 'react'
import { useBackend } from '../../lib/backend.js'
import { projectHref } from '../../lib/ia.js'
import { isStandalone } from '../../lib/shortcut.js'
import { useLocked } from '../lock/ContentLock.js'
import { NewProjectDialog } from '../NewProjectDialog.js'
import { useProjectTabs } from '../tabs/useProjectTabs.js'
import { Explorer } from './Explorer.js'

export function ExplorerPage() {
  const tabs = useProjectTabs()
  const locked = useLocked()
  const b = useBackend()
  const nav = useNavigate()
  const standalone = useMemo(() => isStandalone(), [])
  const [adding, setAdding] = useState(false)
  return (
    <div className="xp-pagewrap">
      <Explorer
        variant="page"
        tabs={tabs.tabs}
        unpinned={tabs.unpinned}
        current="tree"
        standalone={standalone}
        totals={locked ? { needs: 0, running: 0 } : tabs.totals}
        width={0}
        onWidth={() => {}}
        onMove={tabs.move}
        onUnpin={tabs.unpin}
        onPin={tabs.pin}
        onArchive={(id) => void tabs.archive(id)}
        onAdd={() => setAdding(true)}
      />
      {adding ? (
        <NewProjectDialog
          key={b.artifactAccess.accountId}
          onClose={() => setAdding(false)}
          onCreated={(id) => {
            tabs.pin(id)
            void nav({ href: projectHref(id) })
          }}
        />
      ) : null}
    </div>
  )
}
